import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { Observable } from 'rxjs/Observable';
import { ConfigService } from '../../config.service';

@Injectable()
export class Ri5ApiService {

  constructor(
    protected http: HttpClient,
    protected oAuth: OAuthService
  ) {}

  protected get baseUrl(): string {
    return ConfigService.app.baseUri;
  }

  protected get headers(): HttpHeaders {
    return new HttpHeaders({
      'Authorization': `Bearer ${this.oAuth.getAccessToken()}`,
      'Content-Type': 'application/json'
    });
  }

  get<T>(path: string): Observable<T> {
    const url = `${this.baseUrl}/${path}`;
    return this.http.get<T>(url, { headers: this.headers });
  }
}



// WEBPACK FOOTER //
// ./src/app/core/ri5-api/ri5-api.service.ts